const useSSR = () => typeof window === 'undefined';

export default useSSR;
